/* Albatross x Hemisphere - Horizontal ticker: keeps the loop gap-free on very wide screens */
(() => {
  if (customElements.get('hm-hticker')) return;

  class HmHticker extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hm-hticker__track');
      if (!this.track) return;
      this.copySeconds = parseFloat(this.dataset.copySeconds) || 0;
      this.copies = parseInt(this.dataset.copies, 10) || 1;
      this.fill = this.fill.bind(this);
      this.fill();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(this.fill);
        });
        this.ro.observe(this);
      }
      // images change the width once loaded
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.fill, { once: true });
      });
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      cancelAnimationFrame(this.raf);
    }

    fill() {
      const halves = this.track.querySelectorAll(':scope > .hm-hticker__half');
      if (halves.length !== 2) return;
      const first = halves[0];
      const setEl = first.querySelector('.hm-hticker__set');
      if (!setEl) return;
      const setWidth = setEl.getBoundingClientRect().width;
      if (!setWidth) return;
      const viewport = Math.max(this.clientWidth, window.innerWidth || 0);
      const current = first.querySelectorAll(':scope > .hm-hticker__set').length;
      const needed = Math.ceil((viewport + setWidth) / setWidth);
      if (needed <= current) return;
      halves.forEach((half) => {
        for (let i = current; i < needed; i += 1) {
          const clone = setEl.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          half.appendChild(clone);
        }
      });
      if (this.copySeconds) {
        this.style.setProperty('--hm-dur', `${(this.copySeconds * needed).toFixed(2)}s`);
      }
    }
  }

  customElements.define('hm-hticker', HmHticker);
})();
